import { render, staticRenderFns } from "./dishRoom.vue?vue&type=template&id=6be4c3fa&scoped=true"
import script from "./dishRoom.vue?vue&type=script&lang=js"
export * from "./dishRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4c3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be4c3fa')) {
      api.createRecord('6be4c3fa', component.options)
    } else {
      api.reload('6be4c3fa', component.options)
    }
    module.hot.accept("./dishRoom.vue?vue&type=template&id=6be4c3fa&scoped=true", function () {
      api.rerender('6be4c3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/reunionDinnerManagement/restaurantManagement/dishRoom.vue"
export default component.exports